"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
exports.LoadingButton = function (_a) {
    var children = _a.children, loading = _a.loading, props = __rest(_a, ["children", "loading"]);
    return (react_1.default.createElement(Button_1.default, __assign({ style: { padding: 0, overflow: 'hidden' } }, props, { disabled: props.disabled || loading }),
        react_1.default.createElement("div", { style: { width: '100%' } },
            loading && react_1.default.createElement(LinearProgress_1.default, { style: { width: '100%' } }),
            react_1.default.createElement("div", { style: { padding: '6px 16px' } }, children))));
};
//# sourceMappingURL=Loading.js.map